import { lazy } from 'react';

const KEY = 'p2b-chunk-reload';

/**
 * The map module, loaded on demand. After a deploy an open page may ask for a chunk of the previous build that is
 * gone; then reload the page once (a fresh index points at the new chunks) instead of leaving it blank.
 */
function load() {
  return import('./map/maps.js').then(
    (m) => {
      try {
        sessionStorage.removeItem(KEY);
      } catch {
        /* storage blocked */
      }
      return m;
    },
    (err: unknown) => {
      let reloaded: boolean;
      try {
        reloaded = sessionStorage.getItem(KEY) === '1';
        sessionStorage.setItem(KEY, '1');
      } catch {
        reloaded = true; // without storage we cannot tell: do not risk a reload loop
      }
      if (!reloaded) window.location.reload();
      throw err;
    },
  );
}

export const ProjectsMap = lazy(() => load().then((m) => ({ default: m.ProjectsMap })));
export const LocationPicker = lazy(() => load().then((m) => ({ default: m.LocationPicker })));
